<template>
  <div class="floating-side-menu">
    <q-card class="menu-card">
      <!-- Menu Principal com Lista Vertical -->
      <div class="menu-main">
        <!-- Lista de Opções Principais -->
        <q-list class="menu-list">
          <!-- TOP 5 - RESÍDUOS -->
          <q-item
            clickable
            :active="isMenuActive('residuos')"
            @click="handleMenuClick('residuos')"
            class="menu-item residuos"
          >
            <div class="union-block-container">
              <div class="icon-avatar-container">
                <div class="menu-icon">
                  <q-icon name="mdi-delete-forever" size="md" />
                </div>
              </div>
              <div class="text-and-button-container">
                <q-item-label class="menu-text">{{ this.$gettext('INDUSTRIAL_MAP_TOP_5_RESIDUES') }}</q-item-label>
                <q-item-section side class="add-button-section">
                  <q-icon :name="isMenuActive('residuos') ? 'remove' : 'add'" color="grey-6" size="sm" />
                </q-item-section>
              </div>
            </div>
          </q-item>

          <!-- Lista Expandida - RESÍDUOS -->
          <q-slide-transition>
            <div v-show="isMenuActive('residuos')" class="expanded-list residuos-list">
              <q-list dense>
                <q-item
                  v-for="(residuo, index) in getSubmenuData('residuos')"
                  :key="residuo.id"
                  clickable
                  @click="onResiduoClick(residuo)"
                  class="expanded-item residuo-item"
                >
                  <q-item-section class="residuo-content">
                    <div class="residuo-line">
                      <span class="residuo-rank">{{ index + 1 }}º</span>
                      <span class="residuo-name">{{ ('Resíduo ' + residuo.productName) }}</span>
                      <span class="residuo-quantity">{{ (residuo.quantity || '0') }} Kg</span>
                    </div>
                  </q-item-section>
                </q-item>
              </q-list>
            </div>
          </q-slide-transition>

          <!-- TOP 5 - COLETAS -->
          <q-item
            clickable
            :active="isMenuActive('coletas')"
            @click="handleMenuClick('coletas')"
            class="menu-item coletas"
          >
            <div class="union-block-container">
              <div class="icon-avatar-container">
                <div class="menu-icon">
                  <q-icon name="mdi-dump-truck" size="md" />
                </div>
              </div>
              <div class="text-and-button-container">
                <q-item-label class="menu-text">{{ this.$gettext('INDUSTRIAL_MAP_TOP_5_COLLECTIONS') }}</q-item-label>
                <q-item-section side class="add-button-section">
                  <q-icon :name="isMenuActive('coletas') ? 'remove' : 'add'" color="grey-6" size="sm" />
                </q-item-section>
              </div>
            </div>
          </q-item>

          <!-- Lista Expandida - COLETAS -->
          <q-slide-transition>
            <div v-show="isMenuActive('coletas')" class="expanded-list coletas-list">
              <q-list dense>
                <q-item
                  v-for="(coleta, index) in getSubmenuData('coletas')"
                  :key="coleta.collectionPointId || coleta.id"
                  clickable
                  @click="onColetaClick(coleta)"
                  class="expanded-item coleta-item"
                >
                  <q-item-section class="coleta-content">
                    <div class="coleta-line">
                      <span class="coleta-rank">{{ index + 1 }}ª</span>
                      <span class="coleta-name">
                        {{ getColetaCollectionPointName(coleta) }}
                        <q-tooltip>{{ getColetaCollectionPointName(coleta) }}</q-tooltip>
                      </span>
                      <span class="coleta-collections">{{ getColetaTotalCollections(coleta) }} {{ getColetaTotalCollections(coleta) === 1 ? $gettext('INDUSTRIAL_MAP_COLLECTION_SINGULAR') : $gettext('INDUSTRIAL_MAP_COLLECTION_PLURAL') }}</span>
                      <span class="coleta-separator">/</span>
                      <span class="coleta-tons">{{ getColetaTotalTons(coleta) }} T</span>
                    </div>
                  </q-item-section>
                </q-item>
                <q-item
                  clickable
                  @click="onTodasColetasClick"
                  class="expanded-item todas-coletas-item"
                >
                  <q-item-section class="todas-coletas-content">
                    <div class="todas-coletas-line">
                      <span class="todas-coletas-text">{{ this.$gettext("INDUSTRIAL_MAP_ALL_COLLECTIONS") }}</span>
                      <q-icon name="visibility" size="18px" class="todas-coletas-icon" />
                    </div>
                  </q-item-section>
                </q-item>
              </q-list>
            </div>
          </q-slide-transition>

          <!-- RONDAS (esconder se array vazio) -->
          <template v-if="submenus && submenus.rondas && submenus.rondas.length > 0">
          <q-item
            clickable
            :active="isMenuActive('rondas')"
            @click="handleMenuClick('rondas')"
            class="menu-item rondas"
          >
            <div class="union-block-container">
              <div class="icon-avatar-container">
                <div class="menu-icon">
                  <RoundaboutRight />
                </div>
              </div>
              <div class="text-and-button-container">
                <q-item-label class="menu-text">{{ this.$gettext('INDUSTRIAL_MAP_ROUNDS') }}</q-item-label>
                <q-item-section side class="add-button-section">
                  <q-icon :name="isMenuActive('rondas') ? 'remove' : 'add'" color="grey-6" size="sm" />
                </q-item-section>
              </div>
            </div>
          </q-item>

          <!-- Lista Expandida - RONDAS -->
          <q-slide-transition>
            <div v-show="isMenuActive('rondas')" class="expanded-list rondas-list">
              <q-list dense>
                <q-item
                  v-for="ronda in getSubmenuData('rondas')"
                  :key="ronda.id"
                  clickable
                  @click="onRondaClick(ronda)"
                  class="expanded-item ronda-item"
                >
                  <q-item-section class="ronda-content">
                    <div class="ronda-line">
                      <span class="ronda-text">{{ getRondaResponsavel(ronda) }}</span>
                      <q-icon :name="getRondaStatusIcon(ronda)" :color="getRondaStatusIconColor(ronda)" size="20px" class="ronda-icon" />
                    </div>
                  </q-item-section>
                </q-item>
                <q-item
                  clickable
                  @click="onTodasRondasClick"
                  class="expanded-item todas-rondas-item"
                >
                  <q-item-section class="todas-rondas-content">
                    <div class="todas-rondas-line">
                      <span class="todas-rondas-text">{{ this.$gettext('INDUSTRIAL_MAP_ALL_ROUNDS') }}</span>
                      <q-icon name="visibility" size="18px" class="todas-rondas-icon" />
                    </div>
                  </q-item-section>
                </q-item>
              </q-list>
            </div>
          </q-slide-transition>
          </template>

          <!-- CAÇAMBAS TEMPORÁRIAS -->
          <q-item
            clickable
            :active="isMenuActive('cacambas')"
            @click="handleMenuClick('cacambas')"
            class="menu-item cacambas"
          >
            <div class="union-block-container">
              <div class="icon-avatar-container">
                <div class="menu-icon">
                  <TrainCarHopperFull />
                </div>
              </div>
              <div class="text-and-button-container">
                <q-item-label class="menu-text">{{ this.$gettext('INDUSTRIAL_MAP_TEMPORARY_BINS') }}</q-item-label>
                <q-item-section side class="add-button-section">
                  <q-icon :name="isMenuActive('cacambas') ? 'remove' : 'add'" color="grey-6" size="sm" />
                </q-item-section>
              </div>
            </div>
          </q-item>

          <!-- Lista Expandida - CAÇAMBAS -->
          <q-slide-transition>
            <div v-show="isMenuActive('cacambas')" class="expanded-list cacambas-list">
              <q-list dense>
                <q-item
                  v-for="cacamba in getSubmenuData('cacambas')"
                  :key="cacamba.id"
                  clickable
                  @click="onCacambaClick(cacamba)"
                  class="expanded-item cacamba-item"
                >
                  <q-item-section class="cacamba-content">
                    <div class="cacamba-line">
                      <span class="cacamba-text">{{ getCacambaNumero(cacamba) }} - Caçamba - {{ getCacambaApelido(cacamba) }}</span>
                    </div>
                  </q-item-section>
                </q-item>
                <q-item
                  clickable
                  @click="onTodasCacambasClick"
                  class="expanded-item todas-cacambas-item"
                >
                  <q-item-section class="todas-cacambas-content">
                    <div class="todas-cacambas-line">
                      <span class="todas-cacambas-text">{{ this.$gettext('INDUSTRIAL_MAP_ALL_TEMPORARY_CONTAINERS') }}</span>
                      <q-icon name="visibility" size="18px" class="todas-cacambas-icon" />
                    </div>
                  </q-item-section>
                </q-item>
              </q-list>
            </div>
          </q-slide-transition>

          <!-- POSTOS AVANÇADOS -->
        <q-item
            clickable
            :active="isMenuActive('postos')"
            @click="handleMenuClick('postos')"
            class="menu-item postos"
          >
            <div class="union-block-container">
              <div class="icon-avatar-container">
                <div class="menu-icon">
                  <Warehouse />
                </div>
              </div>
              <div class="text-and-button-container">
                <q-item-label class="menu-text">{{ this.$gettext('INDUSTRIAL_MAP_ADVANCED_POSTS') }}</q-item-label>
                <q-item-section side class="add-button-section">
                  <q-icon :name="isMenuActive('postos') ? 'remove' : 'add'" color="grey-6" size="sm" />
                </q-item-section>
              </div>
            </div>
          </q-item>

          <!-- Lista Expandida - POSTOS -->
          <q-slide-transition>
            <div v-show="isMenuActive('postos')" class="expanded-list postos-list">
              <q-list dense>
                <q-item
                  v-for="posto in getSubmenuData('postos')"
                  :key="posto.id"
                  clickable
                  @click="onPostoClick(posto)"
                  class="expanded-item posto-item"
                >
                  <q-item-section class="posto-content">
                    <div class="posto-line">
                      <span class="posto-numero">{{ posto.numero }}</span>
                      <span class="posto-text">{{ posto.name }}</span>
                      <q-icon
                        v-if="posto.criticality === 'red'"
                        name="error"
                        color="negative"
                        size="20px"
                        class="posto-icon"
                      />
                      <q-icon
                        v-else-if="posto.criticality === 'yellow'"
                        name="warning"
                        color="warning"
                        size="20px"
                        class="posto-icon"
                      />
                    </div>
                  </q-item-section>
                </q-item>
              </q-list>
            </div>
          </q-slide-transition>

          <!-- PONTOS COLETA -->
          <q-item
            clickable
            @click="openPontosColetaModal"
            class="menu-item pontos-coleta"
          >
            <div class="union-block-container">
              <div class="icon-avatar-container">
                <div class="menu-icon">
                  <q-icon name="mdi-map-marker" size="md" />
                </div>
              </div>
              <div class="text-and-button-container">
                <q-item-label class="menu-text">{{ this.$gettext('INDUSTRIAL_MAP_MENU_COLLECTION_POINTS') }}</q-item-label>
                <q-item-section side class="add-button-section">
                  <q-icon name="add" color="grey-6" size="sm" />
                </q-item-section>
              </div>
            </div>
          </q-item>
        </q-list>
      </div>
    </q-card>

    <!-- Modal de Detalhes do Resíduo -->
    <ModalDetalhesResidue
      v-model="modalResidue.visible"
      :residue="modalResidue.data"
      @close="closeResidueModal"
      @view-history="onResidueViewHistory"
      @edit="onResidueEdit"
    />

    <!-- Modal de Detalhes da Coleta -->
    <ModalDetalhesColeta
      v-model="modalColeta.visible"
      :coleta="modalColeta.data"
      @close="closeColetaModal"
      @view-history="onColetaViewHistory"
      @edit="onColetaEdit"
    />

    <!-- Modal de Detalhes da Ronda -->
    <ModalDetalhesRondas
      v-model="modalRonda.visible"
      :ronda="modalRonda.data"
      @close="closeRondaModal"
    />

    <!-- Modal de Detalhes da Caçamba Temporária -->
    <ModalCacambaTemporaria
      v-model="modalCacamba.visible"
      :cacamba="modalCacamba.data"
      @close="closeCacambaModal"
    />

    <!-- Modal de Detalhes do Posto Avançado -->
    <ModalDetalhesPostoAvancado
      v-model="modalPostoAvancado.visible"
      :data="modalPostoAvancado.data"
      :compact-view="modalPostoAvancado.compactView"
      @close="closePostoAvancadoModal"
    />

    <!-- Modal de Filtros Dinâmicos para Pontos de Coleta -->
    <ModalFiltrosDinamicos
      v-if="modalPontosColeta.visible"
      key="modal-pontos-coleta"
      v-model="modalPontosColeta.visible"
      :nm-interface="modalPontosColeta.nmInterface"
      :fields="modalPontosColeta.tableFields"
      :forms="modalPontosColeta.forms"
      :relacionamentos="modalPontosColeta.relacionamentos"
      :api-mode="true"
      :extra-params="modalPontosColeta.extraParams"
      :buttons="modalPontosColeta.buttons"
      :selection-force="true"
      :rows-per-page-initial="10"
      :is-paginated="true"
      :row-buttons="false"
      noneselect
      custom-action-slot
      hide-expand-button
      :title="$gettext('INDUSTRIAL_MAP_COLLECTION_POINTS')"
      @close="closePontosColetaModal"
      @search-completed="onPontosColetaSearchCompleted"
      @search-error="onPontosColetaSearchError"
      @action-button="onPontosColetaActionButton"
      @click-row="onPontosColetaRowClick"
      @custom-action="onPontosColetaCustomAction"
    >
      <!-- Slot de ação customizada para abrir detalhes do posto avançado -->
      <template v-slot:body-cell-actions="slotProps">
        <td class="text-center custom-actions-cell" style="padding: 0 !important; vertical-align: middle !important; border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important; background-color: transparent !important;">
          <div style="display: flex; align-items: center; justify-content: center; width: 100%; height: 100%; min-height: 40px; padding: 8px;">
            <q-btn
              color="primary"
              flat
              round
              size="sm"
              @click="handleOpenPostoAvancado(slotProps)"
              style="background-color: transparent !important;"
            >
              <q-icon name="mdi-clipboard-text" />
              <q-tooltip>{{ $gettext('INDUSTRIAL_MAP_VIEW_COLLECTION_POINT_DETAILS') }}</q-tooltip>
            </q-btn>
          </div>
        </td>
      </template>
    </ModalFiltrosDinamicos>

    <!-- Modal de Filtros Dinâmicos para Todas as Coletas -->
    <ModalFiltrosDinamicos
      v-if="modalTodasColetas.visible"
      key="modal-todas-coletas"
      v-model="modalTodasColetas.visible"
      :nm-interface="modalTodasColetas.nmInterface"
      :fields="modalTodasColetas.tableFields"
      :forms="modalTodasColetas.forms"
      :relacionamentos="modalTodasColetas.relacionamentos"
      :api-mode="true"
      :extra-params="modalTodasColetas.extraParams"
      :buttons="modalTodasColetas.buttons"
      :selection-force="true"
      :rows-per-page-initial="10"
      :is-paginated="true"
      :row-buttons="false"
      noneselect
      custom-action-slot
      hide-expand-button
      :title="$gettext('INDUSTRIAL_MAP_ALL_COLLECTIONS_TITLE')"
      :fields-per-row="3"
      show-day-filter
      :day-filter-label="$gettext('INDUSTRIAL_MAP_COLLECTIONS_DONE')"
      @day-filter-change="onTodasColetasDayFilterChange"
      @close="closeTodasColetasModal"
      @search-completed="onTodasColetasSearchCompleted"
      @search-error="onTodasColetasSearchError"
      @action-button="onTodasColetasActionButton"
      @click-row="onTodasColetasRowClick"
    >
      <!-- Slot de ação customizada para abrir detalhes da coleta -->
      <template v-slot:body-cell-actions="slotProps">
        <td class="text-center custom-actions-cell" style="padding: 0 !important; vertical-align: middle !important; border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important; background-color: transparent !important;">
          <div style="display: flex; align-items: center; justify-content: center; width: 100%; height: 100%; min-height: 40px; padding: 8px;">
            <q-btn
              color="primary"
              flat
              round
              size="sm"
              @click="handleOpenColetaDetails(slotProps)"
              style="background-color: transparent !important;"
            >
              <q-icon name="mdi-clipboard-text" />
              <q-tooltip>{{ $gettext('INDUSTRIAL_MAP_VIEW_COLLECTION_DETAILS') }}</q-tooltip>
            </q-btn>
          </div>
        </td>
      </template>

      <template v-slot:custom-expand-content="{ row }">
        <td :colspan="modalTodasColetas.tableFields.length + 1" class="expand-content-container">
          <div class="expand-content-wrapper">
            <!-- Seção de Resíduos -->
            <div class="residuos-section">
              <div class="section-header">
                <q-icon name="science" color="primary" size="18px" class="q-mr-xs" />
                <span class="section-title">{{ this.$gettext('INDUSTRIAL_MAP_ALL_WASTES') }}</span>
                <span class="residuos-count">{{ getResiduesList(row).length }} {{ this.$gettext('INDUSTRIAL_MAP_ITEMS') }}</span>
              </div>

              <div v-if="getResiduesList(row).length > 0" class="residuos-list">
                <div
                  v-for="(residuo, idx) in getResiduesList(row)"
                  :key="`residuo-${idx}`"
                  class="residuo-item"
                >
                  <div class="residuo-info">
                    <span class="residuo-name">{{ residuo.nome || residuo.productName || 'Resíduo' }}</span>
                    <span class="residuo-quantity">{{ formatQuantity(residuo) }}</span>
                  </div>
                  <div class="residuo-details">
                    <span class="residuo-code">{{ residuo.codigo || residuo.productCode || '' }}</span>
                  </div>
                </div>
              </div>

              <div v-else class="no-residuos">
                <q-icon name="info" color="grey-5" size="16px" class="q-mr-xs" />
                <span class="no-data-text">{{ this.$gettext('INDUSTRIAL_MAP_NO_WASTE_FOUND') }}</span>
              </div>
            </div>

            <!-- Seção de Observação (se existir) -->
            <div v-if="row.observacao || row.observation" class="observacao-section">
              <div class="section-header">
                <q-icon name="description" color="orange" size="18px" class="q-mr-xs" />
                <span class="section-title">{{ this.$gettext('INDUSTRIAL_MAP_OBSERVATION') }}</span>
              </div>
              <div class="observacao-content">
                {{ row.observacao || row.observation }}
              </div>
            </div>
          </div>
        </td>
      </template>
    </ModalFiltrosDinamicos>

    <!-- Modal de Filtros Dinâmicos para Todas as Caçambas -->
    <ModalFiltrosDinamicos
      v-if="modalTodasCacambas.visible"
      key="modal-todas-cacambas"
      v-model="modalTodasCacambas.visible"
      :nm-interface="modalTodasCacambas.nmInterface"
      :fields="modalTodasCacambas.tableFields"
      :forms="modalTodasCacambas.forms"
      :relacionamentos="modalTodasCacambas.relacionamentos"
      :api-mode="true"
      :extra-params="modalTodasCacambas.extraParams"
      :buttons="[]"
      :selection-force="true"
      :rows-per-page-initial="10"
      :is-paginated="true"
      :row-buttons="false"
      noneselect
      custom-action-slot
      hide-expand-button
      :title="$gettext('INDUSTRIAL_MAP_ALL_CONTAINERS_TITLE')"
      @close="closeTodasCacambasModal"
      @search-completed="onTodasCacambasSearchCompleted"
      @search-error="onTodasCacambasSearchError"
      @action-button="onTodasCacambasActionButton"
      @click-row="onTodasCacambasRowClick"
      @custom-action="onTodasCacambasCustomAction"
    >
      <!-- Slot de ação customizada para abrir detalhes da caçamba temporária -->
      <template v-slot:body-cell-actions="slotProps">
        <td class="text-center custom-actions-cell" style="padding: 0 !important; vertical-align: middle !important; border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important; background-color: transparent !important;">
          <div style="display: flex; align-items: center; justify-content: center; width: 100%; height: 100%; min-height: 40px; padding: 8px;">
            <q-btn
              color="primary"
              flat
              round
              size="sm"
              @click="handleOpenCacambaTemporariaDetails(slotProps)"
              style="background-color: transparent !important;"
            >
              <q-icon name="mdi-clipboard-text" />
              <q-tooltip>{{ $gettext('INDUSTRIAL_MAP_VIEW_CONTAINER_DETAILS') }}</q-tooltip>
            </q-btn>
          </div>
        </td>
      </template>
    </ModalFiltrosDinamicos>
  </div>
</template>

<script>
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import ModalDetalhesResidue from 'src/components/industrialMap/modals/ModalDetalhesResidue.vue'
import ModalDetalhesColeta from 'src/components/industrialMap/modals/ModalDetalhesColeta.vue'
import ModalDetalhesRondas from 'src/components/industrialMap/modals/ModalDetalhesRondas.vue'
import ModalCacambaTemporaria from 'src/components/industrialMap/modals/ModalCacambaTemporaria.vue'
import RoundaboutRight from 'src/components/industrialMap/icons/RoundaboutRight.vue'
import TrainCarHopperFull from 'src/components/industrialMap/icons/TrainCarHopperFull.vue'
import Warehouse from 'src/components/industrialMap/icons/Warehouse.vue'
import ModalDetalhesPostoAvancado from 'src/components/industrialMap/modals/ModalDetalhesPostoAvancado.vue'
import ModalFiltrosDinamicos from 'src/components/industrialMap/modals/ModalFiltrosDinamicos.vue'
import { IndustrialMapRepository } from 'src/modules/industry/industrial-map/IndustrialMapRepository.js'

@Component({
  name: 'FloatingSideMenu',
  components: {
    ModalDetalhesResidue,
    ModalDetalhesColeta,
    ModalDetalhesRondas,
    ModalCacambaTemporaria,
    RoundaboutRight,
    TrainCarHopperFull,
    Warehouse,
    ModalDetalhesPostoAvancado,
    ModalFiltrosDinamicos
  },
  emits: ['coleta-click']
})
class FloatingSideMenu extends Vue {
  @Prop({ type: Object, default: () => ({}) })
  submenus

  @Prop({ type: Array, default: () => [] })
  value

  // Estado da modal
  modalResidue = {
    visible: false,
    data: null
  }

  modalColeta = {
    visible: false,
    data: null
  }

  modalRonda = {
    visible: false,
    data: null
  }

  modalCacamba = {
    visible: false,
    data: null
  }

  // State for the new modal
  modalPostoAvancado = {
    visible: false,
    data: null,
    compactView: false // true quando aberto a partir de ponto de coleta
  }

  // State for pontos de coleta modal
  modalPontosColeta = {
    visible: false,
    nmInterface: 'collectionPointIndustrialMap.pesquisar',
    tableFields: [],
    forms: [],
    extraParams: {},
    buttons: [],
    headerData: null,
    relacionamentos: {}
  }

  // State for todas coletas modal
  modalTodasColetas = {
    visible: false,
    nmInterface: 'industrialTask.pesquisa',
    tableFields: [],
    forms: [],
    extraParams: {},
    buttons: [],
    headerData: null,
    relacionamentos: {}
  }

  // State for todas cacambas modal
  modalTodasCacambas = {
    visible: false,
    nmInterface: 'industrialTemporaryStorage.pesquisa',
    tableFields: [],
    forms: [],
    extraParams: {},
    buttons: [],
    headerData: null,
    relacionamentos: {}
  }

  get activeTabs () {
    return this.value
  }

  set activeTabs (val) {
    this.$emit('input', val)
  }

  // Verifica se um menu está ativo
  isMenuActive (menuName) {
    return this.activeTabs.includes(menuName)
  }

  // Controle do menu
  handleMenuClick (menuName) {
    const currentTabs = [...this.activeTabs]
    const index = currentTabs.indexOf(menuName)

    if (index > -1) {
      // Remove o menu se já estiver ativo
      currentTabs.splice(index, 1)
    } else {
      // Adiciona o menu se não estiver ativo
      currentTabs.push(menuName)
    }

    this.$emit('input', currentTabs)
  }

  closeSubmenu () {
    this.$emit('input', [])
  }

  async openPontosColetaModal () {
    try {
      // Buscar dados do header para configurar o formulário
      const response = await IndustrialMapRepository.mountCollectionPointSearch()

      if (response && response.header) {
        // Processar a estrutura completa retornada pelo backend
        const headerData = response.header[0] // Primeiro item do array header

        let forms = []
        let datatables = []

        // Verificar se o headerData tem inputs diretamente
        if (headerData.inputs && Array.isArray(headerData.inputs)) {
          // Criar um form com os inputs do header (excluindo DATATABLE)
          const searchInputs = headerData.inputs.filter(input => input.type !== 'DATATABLE')
          forms = [{
            name: headerData.name,
            inputs: searchInputs
          }]

          // Extrair configuração da grid dos inputs DATATABLE
          const datatableInputs = headerData.inputs.filter(input => input.type === 'DATATABLE')
          if (datatableInputs.length > 0) {
            const datatableInput = datatableInputs[0]

            // Criar datatable a partir do input DATATABLE
            if (datatableInput.columns && Array.isArray(datatableInput.columns)) {
              datatables = [{
                nmInterface: datatableInput.nmInterface || headerData.nmInterface,
                columns: datatableInput.columns,
                buttons: datatableInput.buttons || [],
                name: datatableInput.name
              }]
            }
          }
        }

        // Verificar se o headerData tem datatables diretamente
        if (headerData.datatables && Array.isArray(headerData.datatables)) {
          datatables = headerData.datatables
        }

        // Se não encontrou nos inputs diretos, tentar nos forms do header
        if (forms.length === 0 && headerData.forms && Array.isArray(headerData.forms)) {
          forms = headerData.forms
        }

        // Se ainda não encontrou, tentar nos detalhes
        if (forms.length === 0 && response.detalhes && response.detalhes.dadosForm) {
          forms = response.detalhes.dadosForm.forms || []
        }

        if (datatables.length === 0 && response.detalhes && response.detalhes.dadosForm) {
          datatables = response.detalhes.dadosForm.datatables || []
        }

        const firstDataTable = datatables[0] || {}

        // Configurar campos da tabela baseados nas colunas do datatable
        let tableFields = []
        if (firstDataTable.columns && Array.isArray(firstDataTable.columns)) {
          // Separar colunas de ação (botões) das colunas de dados
          const isActionColumn = (col) => {
            const colName = (col.name || '').toLowerCase()
            return col.type === 'ACTION' ||
              colName === 'ações' ||
              colName === 'açào' ||
              colName === 'actions' ||
              colName === 'acciones' ||
              col.field === 'actions' ||
              (col.buttons && col.buttons.length > 0)
          }

          const actionColumns = firstDataTable.columns.filter(isActionColumn)
          const dataColumns = firstDataTable.columns.filter(col => !isActionColumn(col))

          // Já que todas as colunas têm order: undefined, vamos criar uma ordem customizada
          // Definir ordem preferida baseada nos nomes dos campos
          const preferredOrder = ['name', 'areaCode', 'clientName', 'detail', 'scheduledDate']

          const sortedColumns = dataColumns.sort((a, b) => {
            const indexA = preferredOrder.indexOf(a.name) !== -1 ? preferredOrder.indexOf(a.name) : 999
            const indexB = preferredOrder.indexOf(b.name) !== -1 ? preferredOrder.indexOf(b.name) : 999
            return indexA - indexB
          })

          // Criar campos para todas as colunas na ordem correta
          tableFields = sortedColumns.map((col, index) => {
            // Ajustar larguras das colunas para otimizar espaço
            let style = 'width: auto; max-width: 200px; overflow: hidden; text-overflow: ellipsis;'

            if (col.name === 'PONTO DE COLETA' || col.field === 'PONTO DE COLETA') {
              style = 'width: 150px; max-width: 150px;'
            } else if (col.name === 'CÓDIGO DA ÁREA' || col.field === 'CÓDIGO DA ÁREA') {
              style = 'width: 120px; max-width: 120px;'
            } else if (col.name === 'NOME COMPLETO' || col.field === 'NOME COMPLETO') {
              style = 'width: 250px; max-width: 250px;'
            } else if (col.name === 'DETALHE ENDEREÇO' || col.field === 'DETALHE ENDEREÇO') {
              style = 'width: 100px; max-width: 100px;'
            } else if (col.name === 'DATA AGENDADA' || col.field === 'DATA AGENDADA') {
              style = 'width: 120px; max-width: 120px;'
            }

            return {
              name: col.name || col.model,
              label: col.label,
              field: col.name || col.field || col.model, // Usar col.name primeiro para garantir correspondência
              align: 'center',
              sortable: true,
              type: col.type,
              dataType: col.dataType,
              render: col.render,
              visibility: col.visibility || 'show',
              style: style,
              order: col.order || index
            }
          })

          // Adicionar campos ocultos para forçar a exibição do botão de expansão
          tableFields.push({
            name: 'detalhes_ponto',
            label: this.$gettext('INDUSTRIAL_MAP_COLUMN_DETAILS'),
            field: 'detalhes',
            align: 'center',
            sortable: false,
            visibility: 'hidden', // Campo oculto para forçar expansão
            style: 'display: none;'
          })
        }

        // Configurar dados do modal - usar nmInterface do datatable se disponível
        const modalNmInterface = firstDataTable.nmInterface || headerData.nmInterface || 'collectionPointIndustrialMap.pesquisar'
        this.modalPontosColeta.nmInterface = modalNmInterface
        this.modalPontosColeta.tableFields = tableFields
        this.modalPontosColeta.forms = forms
        this.modalPontosColeta.buttons = firstDataTable.buttons || []
        this.modalPontosColeta.headerData = headerData

        // Adicionar os relacionamentos dos detalhes para popular os selects/comboboxes
        this.modalPontosColeta.relacionamentos = response.detalhes?.relacionamentos || {}

        this.modalPontosColeta.extraParams = {
          interface: modalNmInterface
        }
      }

      this.modalPontosColeta.visible = true
    } catch (error) {
      console.error('[FloatingSideMenu] Erro ao carregar dados do formulário:', error)
      this.$q.notify({
        type: 'negative',
        message: this.$gettext('INDUSTRIAL_MAP_ERROR_LOAD_FILTERS')
      })
    }
  }

  getSubmenuTitle () {
    const titles = {
      residuos: this.$gettext('INDUSTRIAL_MAP_TOP_5_RESIDUES'),
      coletas: this.$gettext('INDUSTRIAL_MAP_TOP_5_COLLECTIONS'),
      rondas: this.$gettext('INDUSTRIAL_MAP_ROUNDS'),
      cacambas: this.$gettext('INDUSTRIAL_MAP_TEMPORARY_BINS'),
      postos: this.$gettext('INDUSTRIAL_MAP_ADVANCED_POSTS')
    }
    return titles[this.activeTabs[0]] || ''
  }

  getSubmenuData (menuType) {
    if (!this.submenus) return []

    const dataMap = {
      residuos: this.submenus.topResiduos || [],
      coletas: this.submenus.coletas || [],
      rondas: this.submenus.rondas || [],
      cacambas: this.submenus.cacambas || [],
      postos: this.submenus.postosAvancados || [],
      pontos: this.submenus.pontosColeta || []
    }

    return dataMap[menuType] || []
  }

  // Event handlers
  async onColetaClick (coleta) {
    try {
      // Exibir loading
      this.$q.loading.show({
        message: this.$gettext('INDUSTRIAL_MAP_LOADING_COLLECTION_DETAILS')
      })

      // Buscar detalhes por ponto de coleta usando mountCollectionPointCollectionDetail
      const collectionPointId = coleta.collectionPointId || coleta.id
      const response = await IndustrialMapRepository.mountCollectionPointCollectionDetail(collectionPointId)

      if (response && response.detalhes) {
        const coletaDetalhes = response.detalhes
        this.modalColeta.data = {
          ...coleta,
          detalhes: {
            dadosForm: coletaDetalhes,
            relacionamentos: coletaDetalhes.relacionamentos || {}
          },
          dadosForm: coletaDetalhes,
          relacionamentos: coletaDetalhes.relacionamentos || {}
        }
      } else {
        this.modalColeta.data = coleta
      }

      this.modalColeta.visible = true
      this.$emit('coleta-click', coleta)
    } catch (error) {
      console.error('[FloatingSideMenu] Erro ao carregar detalhes da coleta:', error)
      // Em caso de erro, abrir modal com dados básicos
      this.modalColeta.data = coleta
      this.modalColeta.visible = true
      // Notificar erro
      this.$q.notify({
        type: 'warning',
        message: this.$gettext('INDUSTRIAL_MAP_ERROR_LOAD_COLLECTION_DETAILS')
      })
    } finally {
      this.$q.loading.hide()
    }
  }

  onRondaClick (ronda) {
    this.modalRonda.data = ronda
    this.modalRonda.visible = true
    this.$emit('ronda-click', ronda)
  }

  onPontoClick (ponto) {
    this.$emit('ponto-click', ponto)
  }

  onCacambaClick (cacamba) {
    this.modalCacamba.data = cacamba
    this.modalCacamba.visible = true
    this.$emit('cacamba-click', cacamba)
  }

  onResiduoClick (residuo) {
    // Mapear dados do topResiduos para formato esperado pelo modal
    // Usar o código do produto como ID para buscar detalhes
    const residueMapped = {
      id: residuo.product,
      nome: residuo.productName,
      categoria: (residuo.product && residuo.product.categoria) || 'Classe I - Perigoso',
      codigo: residuo.product, // Usar o product ID diretamente como codigo
      volumeTotal: residuo.quantity,
      unitMeasureType: residuo.unitMeasureType,
      ...residuo
    }

    this.modalResidue.data = residueMapped
    this.modalResidue.visible = true
    this.$emit('residuo-click', residueMapped)
  }

  // Métodos da modal
  closeResidueModal () {
    this.modalResidue.visible = false
    this.modalResidue.data = null
  }

  closeRondaModal () {
    this.modalRonda.visible = false
    this.modalRonda.data = null
  }

  closeCacambaModal () {
    this.modalCacamba.visible = false
    this.modalCacamba.data = null
  }

  onResidueViewHistory (residue) {
    this.$emit('residue-view-history', residue)
  }

  onResidueEdit (residue) {
    this.$emit('residue-edit', residue)
  }

  onColetaViewHistory (coleta) {
    this.$emit('coleta-view-history', coleta)
  }

  onColetaEdit (coleta) {
    this.$emit('coleta-edit', coleta)
  }

  closeColetaModal () {
    this.modalColeta.visible = false
    this.modalColeta.data = null
  }

  // Modified onPostoClick to open the new modal
  onPostoClick (posto) {
    this.modalPostoAvancado.data = posto
    this.modalPostoAvancado.compactView = false // Visualização normal quando aberto pelo mapa
    this.modalPostoAvancado.visible = true
    // Optionally, you might still want to emit an event if other components listen to it
    // this.$emit('posto-click', posto)
  }

  // Close handler for the new modal
  closePostoAvancadoModal () {
    this.modalPostoAvancado.visible = false
    this.modalPostoAvancado.data = null
    this.modalPostoAvancado.compactView = false // Reset para o padrão
  }

  // Handlers para modal de pontos de coleta
  onPontosColetaSearchCompleted (response) {
    // Emitir evento com os resultados
    this.$emit('pontos-coleta-search-results', {
      response,
      results: response.detalhes?.data || []
    })

    this.$q.notify({
      type: 'positive',
      message: this.$gettext('INDUSTRIAL_MAP_SUCCESS_SEARCH')
    })
  }

  onPontosColetaSearchError (error) {
    console.error('[FloatingSideMenu] Erro na pesquisa de pontos de coleta:', error)
    this.$q.notify({
      type: 'negative',
      message: this.$gettext('INDUSTRIAL_MAP_ERROR_SEARCH')
    })
  }

  onPontosColetaActionButton (button, params, context) {
    // Emitir evento para o componente pai processar a ação do botão
    this.$emit('pontos-coleta-action-button', button, params, context)
  }

  onPontosColetaRowClick (row, context) {
    // Emitir evento para o componente pai processar o clique na linha
    this.$emit('pontos-coleta-row-click', row, context)
  }

  closePontosColetaModal () {
    this.modalPontosColeta.visible = false
    this.modalPontosColeta.tableFields = []
    this.modalPontosColeta.forms = []
    this.modalPontosColeta.extraParams = {}
    this.modalPontosColeta.buttons = []
    this.modalPontosColeta.headerData = null
    this.modalPontosColeta.relacionamentos = {}
  }

  // Handler para ação customizada de pontos de coleta
  onPontosColetaCustomAction (data) {
    const { row, actionType } = data
    console.log('[FloatingSideMenu] Custom action triggered:', { row, actionType })
  }

  // Método auxiliar para debugar e chamar openPostoAvancadoFromPontoColeta
  handleOpenPostoAvancado (slotProps) {
    // Tentar extrair o objeto correto - dados podem estar em slotProps.props.row
    const pontoColeta = slotProps.row || slotProps.props?.row || slotProps.props || slotProps
    this.openPostoAvancadoFromPontoColeta(pontoColeta)
  }

  // Método para abrir modal de posto avançado a partir de um ponto de coleta
  async openPostoAvancadoFromPontoColeta (pontoColeta) {
    try {
      // Exibir loading
      this.$q.loading.show({
        message: this.$gettext('INDUSTRIAL_MAP_LOADING_ADVANCED_POST_DETAILS')
      })

      // Buscar dados do posto avançado usando o ID do ponto de coleta
      const postoId = pontoColeta.id || pontoColeta.collectionPointId

      if (!postoId) {
        console.error('[DEBUG] Não foi possível extrair ID. pontoColeta:', pontoColeta)
        throw new Error('ID do ponto de coleta não encontrado')
      }

      // Buscar detalhes do posto avançado usando mountOutpostDetail
      const response = await IndustrialMapRepository.mountOutpostDetail(postoId)

      if (response && response.detalhes) {
        // Abrir modal de posto avançado com os dados retornados
        this.modalPostoAvancado.data = {
          ...pontoColeta,
          ...response.detalhes,
          id: postoId
        }
      } else {
        // Fallback: usar dados básicos do ponto de coleta
        this.modalPostoAvancado.data = {
          id: postoId,
          name: pontoColeta.name || pontoColeta.collectionPointName || 'Posto Avançado',
          ...pontoColeta
        }
      }

      // Definir visualização compacta (sem imagem) quando aberto a partir de ponto de coleta
      this.modalPostoAvancado.compactView = true
      this.modalPostoAvancado.visible = true
    } catch (error) {
      console.error('[FloatingSideMenu] Erro ao carregar detalhes do posto avançado:', error)

      // Em caso de erro, tentar abrir com dados básicos
      this.modalPostoAvancado.data = {
        id: pontoColeta.id || pontoColeta.collectionPointId,
        name: pontoColeta.name || pontoColeta.collectionPointName || 'Posto Avançado',
        ...pontoColeta
      }
      this.modalPostoAvancado.compactView = true
      this.modalPostoAvancado.visible = true

      // Notificar erro
      this.$q.notify({
        type: 'warning',
        message: this.$gettext('INDUSTRIAL_MAP_ERROR_LOAD_ADVANCED_POST_DETAILS')
      })
    } finally {
      this.$q.loading.hide()
    }
  }

  // Método auxiliar para extrair dados e abrir detalhes da coleta
  handleOpenColetaDetails (slotProps) {
    // Tentar extrair o objeto correto - dados podem estar em slotProps.props.row
    const coleta = slotProps.row || slotProps.props?.row || slotProps.props || slotProps
    this.openColetaDetailsFromGrid(coleta)
    console.log(coleta)
  }

  // Método para abrir modal de detalhes da coleta a partir da grid
  async openColetaDetailsFromGrid (coleta) {
    try {
      // Exibir loading
      this.$q.loading.show({
        message: this.$gettext('INDUSTRIAL_MAP_LOADING_COLLECTION_DETAILS')
      })

      // Buscar o ID do grupo de tarefas (industrialTaskGroupId é retornado pela grid)
      const coletaId = coleta.industrialTaskGroupId || coleta.id || coleta.taskId || coleta.industrialTaskId

      if (!coletaId) {
        console.error('[FloatingSideMenu] Não foi possível extrair ID da coleta:', coleta)
        throw new Error('ID da coleta não encontrado')
      }

      // Buscar detalhes completos da coleta usando mountCollectionDetail
      const response = await IndustrialMapRepository.mountCollectionDetail(coletaId)

      if (response && response.detalhes) {
        // Usar os dados do header que contém a estrutura esperada pela modal
        const coletaDetalhes = response.detalhes
        // Configurar dados da modal com a estrutura retornada pelo backend
        this.modalColeta.data = {
          ...coleta, // Manter dados originais da coleta
          id: coletaId,
          detalhes: coletaDetalhes, // Adicionar detalhes completos do backend
          // Mapear campos específicos se necessário
          dadosForm: coletaDetalhes.dadosForm || coletaDetalhes,
          relacionamentos: coletaDetalhes.relacionamentos || {}
        }
      } else {
        // Fallback para dados originais se não conseguir buscar detalhes
        this.modalColeta.data = {
          ...coleta,
          id: coletaId
        }
      }

      this.modalColeta.visible = true
    } catch (error) {
      console.error('[FloatingSideMenu] Erro ao carregar detalhes da coleta:', error)
      // Em caso de erro, abrir modal com dados básicos
      this.modalColeta.data = coleta
      this.modalColeta.visible = true
      // Notificar erro
      this.$q.notify({
        type: 'warning',
        message: this.$gettext('INDUSTRIAL_MAP_ERROR_LOAD_COLLECTION_DETAILS')
      })
    } finally {
      this.$q.loading.hide()
    }
  }

  // Handlers para modal de todas as coletas
  onTodasColetasSearchCompleted (response) {
    // Emitir evento com os resultados
    this.$emit('todas-coletas-search-results', {
      response,
      results: response.detalhes?.data || []
    })

    this.$q.notify({
      type: 'positive',
      message: this.$gettext('INDUSTRIAL_MAP_SUCCESS_SEARCH_COLLECTIONS')
    })
  }

  onTodasColetasSearchError (error) {
    console.error('[FloatingSideMenu] Erro na pesquisa de todas as coletas:', error)
    this.$q.notify({
      type: 'negative',
      message: this.$gettext('INDUSTRIAL_MAP_ERROR_SEARCH_COLLECTIONS')
    })
  }

  onTodasColetasActionButton (button, params, context) {
    // Emitir evento para o componente pai processar a ação do botão
    this.$emit('todas-coletas-action-button', button, params, context)
  }

  onTodasColetasRowClick (row, context) {
    // Emitir evento para o componente pai processar o clique na linha
    this.$emit('todas-coletas-row-click', row, context)
  }

  closeTodasColetasModal () {
    this.modalTodasColetas.visible = false
    this.modalTodasColetas.tableFields = []
    this.modalTodasColetas.forms = []
    this.modalTodasColetas.extraParams = {}
    this.modalTodasColetas.buttons = []
    this.modalTodasColetas.headerData = null
    this.modalTodasColetas.relacionamentos = {}
  }

  onTodasColetasDayFilterChange (days) {
    this.$emit('todas-coletas-day-filter-change', days)
  }

  // Handlers para modal de todas as caçambas
  onTodasCacambasSearchCompleted (response) {
    // Emitir evento com os resultados
    this.$emit('todas-cacambas-search-results', {
      response,
      results: response.detalhes?.data || []
    })

    this.$q.notify({
      type: 'positive',
      message: this.$gettext('INDUSTRIAL_MAP_SUCCESS_SEARCH_CONTAINERS')
    })
  }

  onTodasCacambasSearchError (error) {
    console.error('[FloatingSideMenu] Erro na pesquisa de todas as caçambas:', error)
    this.$q.notify({
      type: 'negative',
      message: this.$gettext('INDUSTRIAL_MAP_ERROR_SEARCH_CONTAINERS')
    })
  }

  onTodasCacambasActionButton (button, params, context) {
    // Emitir evento para o componente pai processar a ação do botão
    this.$emit('todas-cacambas-action-button', button, params, context)
  }

  onTodasCacambasRowClick (row, context) {
    // Emitir evento para o componente pai processar o clique na linha
    this.$emit('todas-cacambas-row-click', row, context)
  }

  onTodasCacambasCustomAction (data) {
    const { row, actionType } = data
    console.log('[FloatingSideMenu] Custom action triggered (caçambas):', { row, actionType })
  }

  // Método auxiliar para extrair dados e abrir detalhes da caçamba temporária
  handleOpenCacambaTemporariaDetails (slotProps) {
    const cacamba = slotProps.row || slotProps.props?.row || slotProps.props || slotProps
    this.openCacambaTemporariaFromGrid(cacamba)
  }

  // Método para abrir modal de detalhes da caçamba temporária a partir da grid
  openCacambaTemporariaFromGrid (cacamba) {
    try {
      const cacambaId = cacamba.id || cacamba.bucketId || cacamba.temporaryStorageId

      if (!cacambaId) {
        console.error('[FloatingSideMenu] Não foi possível extrair ID da caçamba:', cacamba)
      }

      // Configurar dados e abrir modal de caçamba temporária
      this.modalCacamba.data = {
        ...cacamba,
        id: cacambaId
      }
      this.modalCacamba.visible = true
    } catch (error) {
      console.error('[FloatingSideMenu] Erro ao abrir detalhes da caçamba temporária:', error)
      this.$q.notify({
        type: 'warning',
        message: this.$gettext('INDUSTRIAL_MAP_ERROR_LOAD_CONTAINER_DETAILS')
      })
    }
  }

  closeTodasCacambasModal () {
    this.modalTodasCacambas.visible = false
    this.modalTodasCacambas.tableFields = []
    this.modalTodasCacambas.forms = []
    this.modalTodasCacambas.extraParams = {}
    this.modalTodasCacambas.buttons = []
    this.modalTodasCacambas.headerData = null
    this.modalTodasCacambas.relacionamentos = {}
  }

  // Métodos auxiliares para cores e status
  getStatusColor (status) {
    const colors = {
      PENDENTE: 'warning',
      EM_ANDAMENTO: 'info',
      CONCLUIDO: 'positive',
      CANCELADO: 'negative',
      ATRASADA: 'negative'
    }
    return colors[status] || 'grey'
  }

  getRoundStatusColor (status) {
    const colors = {
      INICIADA: 'info',
      EM_ANDAMENTO: 'warning',
      CONCLUIDA: 'positive',
      PAUSADA: 'orange'
    }
    return colors[status] || 'grey'
  }

  getLotacaoColor (percentual) {
    if (percentual >= 90) return 'negative'
    if (percentual >= 70) return 'warning'
    if (percentual >= 50) return 'orange'
    return 'positive'
  }

  // Métodos auxiliares para coletas
  getColetaCollectionPointName (coleta) {
    return coleta.collectionPointName || this.$gettext('INDUSTRIAL_MAP_COLLECTION_POINTS')
  }

  getColetaTotalCollections (coleta) {
    return coleta.totalCollections || 0
  }

  getColetaTotalTons (coleta) {
    return coleta.totalQuantityTons || 0
  }

  onTodasColetasClick () {
    // Abrir modal com dados do findAllCollections
    this.openTodasColetasModal()
  }

  async openTodasColetasModal () {
    try {
      // Buscar dados do header para configurar o formulário usando findAllCollections
      const response = await IndustrialMapRepository.findAllCollections()

      if (response && response.header) {
        // Processar a estrutura completa retornada pelo backend
        const headerData = response.header[0] // Primeiro item do array header

        let forms = []
        let datatables = []

        // Verificar se o headerData tem inputs diretamente
        if (headerData.inputs && Array.isArray(headerData.inputs)) {
          // Criar um form com os inputs do header (excluindo DATATABLE)
          const searchInputs = headerData.inputs.filter(input => input.type !== 'DATATABLE')
          forms = [{
            name: headerData.name,
            inputs: searchInputs
          }]

          // Extrair configuração da grid dos inputs DATATABLE
          const datatableInputs = headerData.inputs.filter(input => input.type === 'DATATABLE')
          if (datatableInputs.length > 0) {
            const datatableInput = datatableInputs[0]

            // Criar datatable a partir do input DATATABLE
            if (datatableInput.columns && Array.isArray(datatableInput.columns)) {
              datatables = [{
                nmInterface: datatableInput.nmInterface || headerData.nmInterface,
                columns: datatableInput.columns,
                buttons: datatableInput.buttons || [],
                name: datatableInput.name
              }]
            }
          }
        }

        // Verificar se o headerData tem datatables diretamente
        if (headerData.datatables && Array.isArray(headerData.datatables)) {
          datatables = headerData.datatables
        }

        // Se não encontrou nos inputs diretos, tentar nos forms do header
        if (forms.length === 0 && headerData.forms && Array.isArray(headerData.forms)) {
          forms = headerData.forms
        }

        // Se ainda não encontrou, tentar nos detalhes
        if (forms.length === 0 && response.detalhes && response.detalhes.dadosForm) {
          forms = response.detalhes.dadosForm.forms || []
        }

        if (datatables.length === 0 && response.detalhes && response.detalhes.dadosForm) {
          datatables = response.detalhes.dadosForm.datatables || []
        }

        const firstDataTable = datatables[0] || {}

        // Configurar campos da tabela baseados nas colunas do datatable
        let tableFields = []
        if (firstDataTable.columns && Array.isArray(firstDataTable.columns)) {
          // Separar colunas de ação (botões) das colunas de dados
          const isActionColumn = (col) => {
            const colName = (col.name || '').toLowerCase()
            return col.type === 'ACTION' ||
              colName === 'ações' ||
              colName === 'açào' ||
              colName === 'actions' ||
              colName === 'acciones' ||
              col.field === 'actions' ||
              (col.buttons && col.buttons.length > 0)
          }

          const actionColumns = firstDataTable.columns.filter(isActionColumn)
          const dataColumns = firstDataTable.columns.filter(col => !isActionColumn(col))

          // Definir ordem preferida para as colunas de coletas
          const preferredOrder = ['taskCode', 'clientName', 'outpostName', 'scheduledDate', 'vehiclePlate', 'status']

          const sortedColumns = dataColumns.sort((a, b) => {
            const indexA = preferredOrder.indexOf(a.name) !== -1 ? preferredOrder.indexOf(a.name) : 999
            const indexB = preferredOrder.indexOf(b.name) !== -1 ? preferredOrder.indexOf(b.name) : 999
            return indexA - indexB
          })

          // Criar campos para todas as colunas na ordem correta
          tableFields = sortedColumns.map((col, index) => {
            // Ajustar larguras das colunas para otimizar espaço
            let style = 'width: auto; max-width: 200px; overflow: hidden; text-overflow: ellipsis;'

            if (col.name === 'taskCode' || col.field === 'taskCode') {
              style = 'width: 120px; max-width: 120px;'
            } else if (col.name === 'clientName' || col.field === 'clientName') {
              style = 'width: 180px; max-width: 180px;'
            } else if (col.name === 'outpostName' || col.field === 'outpostName') {
              style = 'width: 200px; max-width: 200px;'
            } else if (col.name === 'scheduledDate' || col.field === 'scheduledDate') {
              style = 'width: 120px; max-width: 120px;'
            } else if (col.name === 'vehiclePlate' || col.field === 'vehiclePlate') {
              style = 'width: 100px; max-width: 100px;'
            } else if (col.name === 'status' || col.field === 'status') {
              style = 'width: 100px; max-width: 100px;'
            }

            return {
              name: col.name || col.model,
              label: col.label,
              field: col.name || col.field || col.model,
              align: 'center',
              sortable: true,
              type: col.type,
              dataType: col.dataType,
              render: col.render,
              visibility: col.visibility || 'show',
              style: style,
              order: col.order || index
            }
          })

          // Adicionar campos ocultos para forçar a exibição do botão de expansão
          tableFields.push({
            name: 'residuos_detalhes',
            label: this.$gettext('INDUSTRIAL_MAP_COLUMN_RESIDUES'),
            field: 'residuos',
            align: 'center',
            sortable: false,
            visibility: 'hidden', // Campo oculto para forçar expansão
            style: 'display: none;'
          })

          tableFields.push({
            name: 'observacao_detalhes',
            label: this.$gettext('INDUSTRIAL_MAP_COLUMN_OBSERVATION'),
            field: 'observacao',
            align: 'center',
            sortable: false,
            visibility: 'hidden', // Campo oculto para forçar expansão
            style: 'display: none;'
          })
        }

        // Configurar dados do modal - usar nmInterface do datatable se disponível
        const modalNmInterface = firstDataTable.nmInterface || headerData.nmInterface || 'industrialTask.pesquisar'
        this.modalTodasColetas.nmInterface = modalNmInterface
        this.modalTodasColetas.tableFields = tableFields
        this.modalTodasColetas.forms = forms
        this.modalTodasColetas.buttons = firstDataTable.buttons || []
        this.modalTodasColetas.headerData = headerData

        // Adicionar os relacionamentos dos detalhes para popular os selects/comboboxes
        this.modalTodasColetas.relacionamentos = headerData.relacionamentos || {}

        this.modalTodasColetas.extraParams = {
          grid: IndustrialMapRepository.gridPesquisa,
          interface: modalNmInterface
        }
      }

      this.modalTodasColetas.visible = true
    } catch (error) {
      console.error('[FloatingSideMenu] Erro ao carregar dados de todas as coletas:', error)
      this.$q.notify({
        type: 'negative',
        message: this.$gettext('INDUSTRIAL_MAP_ERROR_LOAD_ALL_COLLECTIONS')
      })
    }
  }

  async openTodasCacambasModal () {
    try {
      // Buscar dados do header para configurar o formulário usando findAllCacambas
      const response = await IndustrialMapRepository.findAllCacambas()

      if (response && response.header) {
        // Processar a estrutura completa retornada pelo backend
        const headerData = response.header[0] // Primeiro item do array header

        let forms = []
        let datatables = []

        // Verificar se o headerData tem inputs diretamente
        if (headerData.inputs && Array.isArray(headerData.inputs)) {
          // Criar um form com os inputs do header (excluindo DATATABLE)
          const searchInputs = headerData.inputs.filter(input => input.type !== 'DATATABLE')
          forms = [{
            name: headerData.name,
            inputs: searchInputs
          }]

          // Extrair configuração da grid dos inputs DATATABLE
          const datatableInputs = headerData.inputs.filter(input => input.type === 'DATATABLE')
          if (datatableInputs.length > 0) {
            const datatableInput = datatableInputs[0]

            // Criar datatable a partir do input DATATABLE
            if (datatableInput.columns && Array.isArray(datatableInput.columns)) {
              datatables = [{
                nmInterface: datatableInput.nmInterface || headerData.nmInterface,
                columns: datatableInput.columns,
                buttons: datatableInput.buttons || [],
                name: datatableInput.name
              }]
            }
          }
        }

        // Verificar se o headerData tem datatables diretamente
        if (headerData.datatables && Array.isArray(headerData.datatables)) {
          datatables = headerData.datatables
        }

        // Se não encontrou nos inputs diretos, tentar nos forms do header
        if (forms.length === 0 && headerData.forms && Array.isArray(headerData.forms)) {
          forms = headerData.forms
        }

        // Se ainda não encontrou, tentar nos detalhes
        if (forms.length === 0 && response.detalhes && response.detalhes.dadosForm) {
          forms = response.detalhes.dadosForm.forms || []
        }

        if (datatables.length === 0 && response.detalhes && response.detalhes.dadosForm) {
          datatables = response.detalhes.dadosForm.datatables || []
        }

        const firstDataTable = datatables[0] || {}

        // Configurar campos da tabela baseados nas colunas do datatable
        let tableFields = []
        if (firstDataTable.columns && Array.isArray(firstDataTable.columns)) {
          // Separar colunas de ação (botões) das colunas de dados
          const isActionColumn = (col) => {
            const colName = (col.name || '').toLowerCase()
            return col.type === 'ACTION' ||
              colName === 'ações' ||
              colName === 'açào' ||
              colName === 'actions' ||
              colName === 'acciones' ||
              col.field === 'actions' ||
              (col.buttons && col.buttons.length > 0)
          }

          const actionColumns = firstDataTable.columns.filter(isActionColumn)
          const dataColumns = firstDataTable.columns.filter(col => !isActionColumn(col))

          // Definir ordem preferida para as colunas de caçambas
          const preferredOrder = ['bucketCode', 'collectionPointName', 'capacity', 'currentVolume', 'status', 'installationDate']

          const sortedColumns = dataColumns.sort((a, b) => {
            const indexA = preferredOrder.indexOf(a.name) !== -1 ? preferredOrder.indexOf(a.name) : 999
            const indexB = preferredOrder.indexOf(b.name) !== -1 ? preferredOrder.indexOf(b.name) : 999
            return indexA - indexB
          })

          // Criar campos para todas as colunas na ordem correta
          tableFields = sortedColumns.map((col, index) => {
            // Ajustar larguras das colunas para otimizar espaço
            let style = 'width: auto; max-width: 200px; overflow: hidden; text-overflow: ellipsis;'

            if (col.name === 'bucketCode' || col.field === 'bucketCode') {
              style = 'width: 120px; max-width: 120px;'
            } else if (col.name === 'collectionPointName' || col.field === 'collectionPointName') {
              style = 'width: 200px; max-width: 200px;'
            } else if (col.name === 'capacity' || col.field === 'capacity') {
              style = 'width: 100px; max-width: 100px;'
            } else if (col.name === 'currentVolume' || col.field === 'currentVolume') {
              style = 'width: 120px; max-width: 120px;'
            } else if (col.name === 'status' || col.field === 'status') {
              style = 'width: 100px; max-width: 100px;'
            } else if (col.name === 'installationDate' || col.field === 'installationDate') {
              style = 'width: 130px; max-width: 130px;'
            }

            return {
              name: col.name || col.model,
              label: col.label,
              field: col.name || col.field || col.model,
              align: 'center',
              sortable: true,
              type: col.type,
              dataType: col.dataType,
              render: col.render,
              visibility: col.visibility || 'show',
              style: style,
              order: col.order || index
            }
          })

          // Adicionar coluna de ações para o botão de detalhe
          tableFields.push({
            name: 'actions',
            label: this.$gettext('INDUSTRIAL_MAP_COLUMN_ACTIONS'),
            field: 'actions',
            align: 'center',
            sortable: false,
            style: 'width: 100px; max-width: 100px;',
            visibility: 'show'
          })
        }

        // Configurar dados do modal - usar nmInterface do datatable se disponível
        const modalNmInterface = firstDataTable.nmInterface || headerData.nmInterface || 'temporaryBucket.pesquisa'
        this.modalTodasCacambas.nmInterface = modalNmInterface
        this.modalTodasCacambas.tableFields = tableFields
        this.modalTodasCacambas.forms = forms
        this.modalTodasCacambas.buttons = []
        this.modalTodasCacambas.headerData = headerData

        // Adicionar os relacionamentos dos detalhes para popular os selects/comboboxes
        this.modalTodasCacambas.relacionamentos = headerData.relacionamentos || {}

        this.modalTodasCacambas.extraParams = {
          grid: IndustrialMapRepository.gridPesquisa,
          interface: modalNmInterface
        }
      }

      this.modalTodasCacambas.visible = true
    } catch (error) {
      console.error('[FloatingSideMenu] Erro ao carregar dados de todas as caçambas:', error)
      this.$q.notify({
        type: 'negative',
        message: this.$gettext('INDUSTRIAL_MAP_ERROR_LOAD_ALL_CONTAINERS')
      })
    }
  }

  // Métodos auxiliares para rondas
  getRondaResponsavel (ronda) {
    return ronda.driverName || ronda.driver?.name || 'Nome Responsável'
  }

  getRondaStatusIcon (ronda) {
    const status = ronda.status || ''
    const percentual = ronda.percentualConcluido || 0

    if (status === 'CONCLUIDA' || status === 'FINALIZADA' || percentual === 100) {
      return 'check_circle'
    }

    return 'schedule'
  }

  getRondaStatusIconColor (ronda) {
    const status = ronda.status || ''
    const percentual = ronda.percentualConcluido || 0

    if (status === 'CONCLUIDA' || status === 'FINALIZADA' || percentual === 100) {
      return 'positive'
    }

    return 'grey-6'
  }

  onTodasRondasClick () {
    // Emitir evento para abrir modal ou página de todas as rondas
    this.$emit('todas-rondas-click')
  }

  // Métodos auxiliares para expansão de conteúdo das coletas
  getResiduesList (row) {
    // Tentar diferentes propriedades onde os resíduos podem estar
    if (row.residuos && Array.isArray(row.residuos)) {
      return row.residuos
    }

    if (row.residues && Array.isArray(row.residues)) {
      return row.residues
    }

    if (row.productos && Array.isArray(row.productos)) {
      return row.productos
    }

    if (row.products && Array.isArray(row.products)) {
      return row.products
    }

    // Se não encontrar array de resíduos, criar um item único se houver dados de produto
    if (row.productName || row.productCode) {
      return [{
        nome: row.productName,
        codigo: row.productCode,
        quantidade: row.quantity,
        unidade: row.unitMeasureType
      }]
    }

    return []
  }

  formatQuantity (residuo) {
    const quantidade = residuo.quantidade || residuo.quantity || 0
    const unidade = residuo.unidade || residuo.unitMeasureType || residuo.unit || 'UN'

    if (quantidade && unidade) {
      return `${quantidade} ${unidade}`
    }

    if (quantidade) {
      return `${quantidade}`
    }

    return 'N/A'
  }

  // Métodos auxiliares para caçambas
  getCacambaApelido (cacamba) {
    return cacamba.collectionPointName || 'CPD'
  }

  getCacambaNumero (cacamba) {
    return cacamba.bucketCode || '0000'
  }

  onTodasCacambasClick () {
    // Abrir modal com dados do findAllCacambas
    this.openTodasCacambasModal()
  }

  // Método auxiliar para formatação de data
  formatDate (dateString) {
    if (!dateString) return 'N/A'

    try {
      const date = new Date(dateString)
      return date.toLocaleDateString('pt-BR')
    } catch (error) {
      return dateString
    }
  }
}

export default FloatingSideMenu
</script>

<style lang="stylus" scoped>
@import '~quasar-variables'

.floating-side-menu
  width: 100%
  height: 100%

  .menu-card
    background: #F5F5F5
    border-radius: 4px
    margin: 20px
    overflow: hidden

    .menu-main
      display: flex
      flex-direction: column
      align-items: center
      gap: 1px
      border-radius: 0 0 4px 4px
      background: #F5F5F5
      width: 288px;

      .menu-list
        width: 100%

        .menu-item:not(:last-child)
          border-bottom: 1px solid #0062a9 !important

        .menu-item
          display: flex !important
          width: 288px !important
          height: 40px !important
          padding: 10px 16px !important
          flex-direction: row !important
          align-items: center !important
          background: #F5F5F5 !important
          border: none !important
          border-radius: 0 !important
          position: relative !important

          .union-block-container
            display: flex
            width: 256px
            height: 20px
            gap: 12px
            align-items: center

          .icon-avatar-container
            width: 20px
            height: 20px
            display: flex
            align-items: center
            color: #0062a9
            justify-content: center
            font-size: 20px

            & .menu-icon
              & .q-icon
                font-size: 20px !important
              & svg
                fill: #0062a9 !important

          .text-and-button-container
            display: flex
            flex-direction: row
            align-items: center
            justify-content: space-between
            width: 224px
            height: 19px

            .menu-text
              flex-grow: 1
              white-space: nowrap
              color: #0062a9 !important

            .add-button-section
              width: 24px !important
              height: 24px !important
              flex-shrink: 0 !important
              display: flex !important
              align-items: center !important
              justify-content: flex-end !important
              padding-right: 8px

              .q-icon
                color: #0062a9 !important

          &:hover
            background: #0E88E4 !important

            .menu-text
              color: white !important

            .add-button-section .q-icon
              color: white !important

            .icon-avatar-container .menu-icon .q-icon
              color: white !important // Avatar icon white on hover
            .icon-avatar-container .menu-icon > svg
              /deep/.roundabout-right-icon-path
                fill: white !important
              /deep/.train-car-hopper-full-icon-path
                fill: white !important
              /deep/.warehouse-icon-path
                fill: white !important

          &.q-item--active
            background: #0E88E4 !important

            .menu-text
              color: white !important

            .icon-avatar-container .menu-icon .q-icon
              color: white !important
            .icon-avatar-container .menu-icon .roundabout-right-icon-path
              fill: white !important

            .add-button-section .q-icon
              color: white !important

            .q-icon
              color: white !important
            .svg-icon
              color: white !important

          .q-item__section--avatar
            min-width: 24px !important
            flex-shrink: 0 !important

            .menu-icon
              width: 20px
              height: 20px
              display: flex
              align-items: center
              justify-content: center

              .q-icon
                color: #0062a9 !important
                font-size: 20px !important

          .q-item__section--main
            flex: 1 !important
            text-align: left !important

            .menu-text
              color: #0062A9 !important
              font-family: Roboto;
              font-weight: 400;
              font-style: Regular;
              font-size: 16px;
              leading-trim: NONE;
              line-height: 100%;
              letter-spacing: 0%;
              text-transform: uppercase;

          .menu-item.cacambas .menu-text
            white-space: nowrap // Prevent text from breaking line

          .menu-text-and-button-container
            display: flex
            flex-direction: row
            align-items: center
            justify-content: space-between
            flex-grow: 1 // Allow it to take available space
            width: 224px // Set explicit width
            height: 19px // Set explicit height

            .menu-text
              flex-grow: 1 // Allow text to take available space
              white-space: nowrap // Ensure text doesn't wrap

            .add-button-section
              width: 24px !important
              height: 24px !important
              flex-shrink: 0 !important
              display: flex !important
              align-items: center !important
              justify-content: flex-end !important // Align to the right
              padding-right: 8px // Add some padding to move it further left

              .q-icon
                color: #0062A9 !important // Default blue color

        .expanded-list
          background: #E8E8E8
          width: 100%

          .expanded-item
            padding: 8px 16px
            background: #E8E8E8
            border-bottom: 1px solid #DADADA

            &:hover
              background: rgba(14, 136, 228, 0.1)

            .q-item-label
              font-size: 12px
              line-height: 1.3

            .q-item-label--caption
              font-size: 10px
              opacity: 0.7
              margin-top: 1px

          // Estilos específicos para lista de resíduos
          &.residuos-list
            .residuo-item
              padding: 10px 16px
              min-height: 40px

              .residuo-content
                padding: 0

              .residuo-line
                display: flex
                align-items: center
                gap: 8px
                width: 100%

                .residuo-rank
                  color: #0062A9
                  font-weight: 700
                  font-size: 14px
                  min-width: 24px
                  flex-shrink: 0

                .residuo-name
                  color: #0062A9
                  font-weight: 400
                  font-size: 14px
                  flex: 1
                  white-space: nowrap
                  overflow: hidden
                  text-overflow: ellipsis

                .residuo-quantity
                  color: #0062A9
                  font-weight: 400
                  font-size: 14px
                  white-space: nowrap
                  flex-shrink: 0

          // Estilos específicos para lista de coletas
          &.coletas-list
            .coleta-item
              padding: 10px 16px
              min-height: 40px

              .coleta-content
                padding: 0

              .coleta-line
                display: flex
                align-items: center
                width: 100%
                gap: 4px

                .coleta-rank
                  color: #0062A9
                  font-weight: 700
                  font-size: 14px
                  min-width: 20px
                  flex-shrink: 0

                .coleta-name
                  color: #0062A9
                  font-weight: 400
                  font-size: 14px
                  white-space: nowrap
                  overflow: hidden
                  text-overflow: ellipsis
                  flex: 1
                  min-width: 0

                .coleta-separator
                  color: #0062A9
                  font-size: 14px
                  flex-shrink: 0

                .coleta-collections
                  color: #0062A9
                  font-weight: 400
                  font-size: 12px
                  white-space: nowrap
                  flex-shrink: 0

                .coleta-tons
                  color: #0062A9
                  font-weight: 700
                  font-size: 12px
                  white-space: nowrap
                  flex-shrink: 0

            .todas-coletas-item
              padding: 10px 16px
              min-height: 40px
              border-bottom: none !important

              .todas-coletas-content
                padding: 0

              .todas-coletas-line
                display: flex
                align-items: center
                justify-content: center
                gap: 8px
                width: 100%

                .todas-coletas-text
                  color: #0062A9
                  font-weight: 700
                  font-size: 14px

                .todas-coletas-icon
                  color: #0062A9

              &:hover
                .todas-coletas-text
                  color: #0E88E4

                .todas-coletas-icon
                  color: #0E88E4

          // Estilos específicos para lista de rondas
          &.rondas-list
            .ronda-item
              padding: 10px 16px
              min-height: 40px

              .ronda-content
                padding: 0

              .ronda-line
                display: flex
                align-items: center
                justify-content: space-between
                width: 100%

                .ronda-text
                  color: #0062A9
                  font-weight: 400
                  font-size: 14px
                  flex: 1
                  white-space: nowrap
                  overflow: hidden
                  text-overflow: ellipsis

                .ronda-icon
                  flex-shrink: 0
                  margin-left: 8px

            .todas-rondas-item
              padding: 10px 16px
              min-height: 40px
              border-bottom: none !important

              .todas-rondas-content
                padding: 0

              .todas-rondas-line
                display: flex
                align-items: center
                justify-content: center
                gap: 8px
                width: 100%

                .todas-rondas-text
                  color: #0062A9
                  font-weight: 700
                  font-size: 14px

                .todas-rondas-icon
                  color: #0062A9

              &:hover
                .todas-rondas-text
                  color: #0E88E4

                .todas-rondas-icon
                  color: #0E88E4

          // Estilos específicos para lista de caçambas
          &.cacambas-list
            .cacamba-item
              padding: 10px 16px
              min-height: 40px

              .cacamba-content
                padding: 0

              .cacamba-line
                display: flex
                align-items: center
                width: 100%

                .cacamba-text
                  color: #0062A9
                  font-weight: 400
                  font-size: 14px
                  white-space: nowrap
                  overflow: hidden
                  text-overflow: ellipsis

            .todas-cacambas-item
              padding: 10px 16px
              min-height: 40px
              border-bottom: none !important

              .todas-cacambas-content
                padding: 0

              .todas-cacambas-line
                display: flex
                align-items: center
                justify-content: center
                gap: 8px
                width: 100%

                .todas-cacambas-text
                  color: #0062A9
                  font-weight: 700
                  font-size: 14px

                .todas-cacambas-icon
                  color: #0062A9

              &:hover
                .todas-cacambas-text
                  color: #0E88E4

                .todas-cacambas-icon
                  color: #0E88E4

          // Estilos específicos para lista de postos
          &.postos-list
            .posto-item
              padding: 10px 16px
              min-height: 40px

              .posto-content
                padding: 0

              .posto-line
                display: flex
                align-items: center
                gap: 8px
                width: 100%

                .posto-numero
                  color: #0062A9
                  font-weight: 700
                  font-size: 14px
                  min-width: 20px
                  flex-shrink: 0

                .posto-text
                  color: #0062A9
                  font-weight: 400
                  font-size: 14px
                  flex: 1
                  white-space: nowrap
                  overflow: hidden
                  text-overflow: ellipsis

                .posto-icon
                  flex-shrink: 0
                  margin-left: auto

// ========================================
// ESTILOS PARA CONTEÚDO DE EXPANSÀO
// ========================================

.expand-content-container
  padding: 0 !important

.expand-content-wrapper
  padding: 16px 24px
  background-color: #f8f9fa
  border-top: 1px solid #e9ecef

.section-header
  display: flex
  align-items: center
  margin-bottom: 12px
  gap: 8px

  .section-title
    font-weight: 600
    font-size: 14px
    color: #333
    margin-right: auto

  .residuos-count
    background-color: #e3f2fd
    color: #1976d2
    padding: 2px 8px
    border-radius: 12px
    font-size: 12px
    font-weight: 500

.residuos-section
  margin-bottom: 16px

  .residuos-list
    display: flex
    flex-direction: column
    gap: 8px

    .residuo-item
      background-color: white
      border: 1px solid #e0e0e0
      border-radius: 6px
      padding: 12px
      transition: all 0.2s ease

      &:hover
        border-color: #1976d2
        box-shadow: 0 2px 4px rgba(25, 118, 210, 0.1)

      .residuo-info
        display: flex
        justify-content: space-between
        align-items: center
        margin-bottom: 4px

        .residuo-name
          font-weight: 500
          font-size: 13px
          color: #333
          flex: 1

        .residuo-quantity
          font-weight: 600
          font-size: 13px
          color: #1976d2
          background-color: #e3f2fd
          padding: 2px 8px
          border-radius: 4px

      .residuo-details
        .residuo-code
          font-size: 12px
          color: #666
          font-family: monospace

  .no-residuos
    display: flex
    align-items: center
    padding: 12px
    background-color: #f5f5f5
    border: 1px dashed #ccc
    border-radius: 6px
    color: #666

    .no-data-text
      font-size: 13px

.observacao-section
  .observacao-content
    background-color: white
    border: 1px solid #e0e0e0
    border-radius: 6px
    padding: 12px
    font-size: 13px
    color: #333
    line-height: 1.4

.detalhes-section
  margin-bottom: 16px

  .detalhes-content
    background-color: white
    border: 1px solid #e0e0e0
    border-radius: 6px
    padding: 12px

    .detalhe-item
      margin-bottom: 8px
      font-size: 13px
      color: #333

      &:last-child
        margin-bottom: 0

      strong
        color: #1976d2
        margin-right: 8px
</style>
